import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useEffect } from 'react';
import { EsriMapStore, EsriMapBootstrapData } from '../stores/esri-map-store';
import { useEsriMapResource } from './use-esri-map-resource';

export const useEsriMapBootstrap = (
    esriMapStore: EsriMapStore
): UseQueryResult<EsriMapBootstrapData> => {
    const { getMapCompositeView } = useEsriMapResource();
    const getEsriMapStoreBootstrapDataQuery = useQuery(
        ['esri-map-bootstrap'],
        async () => {
            const esriMapStoreStateBootstrapData = await getMapCompositeView();
            return esriMapStoreStateBootstrapData;
        },
        {
            cacheTime: Infinity,
            refetchOnMount: false,
            retry: 2,
            refetchOnWindowFocus: false,
            staleTime: Infinity,
        }
    );

    const { isError, refetch, isFetching, data } = getEsriMapStoreBootstrapDataQuery;

    useEffect(() => {
        esriMapStore.setMapBootstrapState({
            isFetching,
            isError,
            refetch,
            mapCenter: data?.mapCenter,
        });
    }, [isFetching, isError, refetch, esriMapStore, data?.mapCenter]);

    return getEsriMapStoreBootstrapDataQuery;
};
